import React from "react";
import { Redirect } from "react-router-dom";

// The promotions screen now creates promotions in a dialog on the list
// page itself (see shopAdminViews/promotions/Promotions.js), so this
// route is kept only so old links and bookmarks to /shopAdmin/addPromotion
// still land somewhere useful — it opens the "Add promotion" dialog.
const ShopAddPromotion = () => <Redirect to="/shopAdmin/promotions?new=1" />;

export default ShopAddPromotion;
